export const DEFAULT_COMPANY_SUPPORT_PHONE_NUMBER = '+33970808057';

export const BO_EXTERNAL_COMPANY_SUPPORT_PHONE_NUMBER = '+33970808595';
